'use client';
import FullscreenExitRoundedIcon from '@mui/icons-material/FullscreenExitRounded';
import { Guess } from '@wt/app/game/_components/types';
import MapResults from '@wt/shared/components/maps/mapkit/map-results';
import useKeypress from '@wt/shared/hooks/useKeyPress';
import { isChecked } from '@wt/shared/hooks/utils/isChecked';
import { MapDistancePoints } from '@wt/shared/libs/mapkit/components/MapDistancePoints';

import ModalLayout from '../layouts/ModalLayout';
import { smallButtonClasses } from '@wt/shared/components/buttons/SmallButton';

interface MapModalProps {
  id: string;
  guess: Guess;
}

export const MapDistanceModal = ({ id, guess }: MapModalProps) => {
  useKeypress('Escape', () => {
    const t = document.getElementById(id);
    t && isChecked(t) && t.click();
  });

  const froms = guess.locationSecondary
    ? [
        [guess.location.latitude, guess.location.longitude],
        [guess.locationSecondary.latitude, guess.locationSecondary.longitude],
      ]
    : [[guess.location.latitude, guess.location.longitude]];

  return (
    <ModalLayout htmlFor={id}>
      <div className="absolute inset-0">
        <MapResults>
          <MapDistancePoints
            froms={froms}
            to={[guess.puzzle.latitude, guess.puzzle.longitude]}
          />
        </MapResults>
      </div>
      <label
        htmlFor={id}
        className={`pointer-events-auto absolute right-4 top-4 z-[99] ${smallButtonClasses}`}
      >
        <FullscreenExitRoundedIcon htmlColor="black" />
      </label>
    </ModalLayout>
  );
};

export default MapDistanceModal;
